/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Tournated Dashboard API
 * Internal REST API consumed by the Tournated dashboard. Authenticated with a user JWT (Authorization: Bearer ...).
 * OpenAPI spec version: 1.0
 */

/**
 * Payment method / channel. Coerced case-insensitively from the DB column; unknown / missing values default to `FREE` (preserves the legacy GraphQL mapper contract). Never null.
 */
export type PurchasedLicensePaymentMethod =
  (typeof PurchasedLicensePaymentMethod)[keyof typeof PurchasedLicensePaymentMethod];

export const PurchasedLicensePaymentMethod = {
  FREE: "FREE",
  ONLINE: "ONLINE",
  BANK_TRANSFER: "BANK_TRANSFER",
  CASH: "CASH",
} as const;
